// Debounce function to avoid excessive calls during resize
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Object to store cloned elements, positions, and current references
let clonedElements = {
  mobile: null,
  desktop: null,
  mobileParent: null,
  mobileIndex: -1,
  desktopParent: null,
  desktopIndex: -1
};
let currentElements = {
  mobile: null,
  desktop: null
};

// Function to save initial clones (runs only once on load)
function saveClonedElements() {
  const mobileTab = document.querySelector('.tab-container.mobile-tabs.collection_wr-wrapper.page-width');
  const desktopTab = document.querySelector('.tab-container.desktop-tabs.collection_wr-wrapper.page-width');
  
  if (mobileTab) {
    clonedElements.mobile = mobileTab.cloneNode(true); // Deep clone: keeps all children and attributes
    clonedElements.mobileParent = mobileTab.parentNode;
    clonedElements.mobileIndex = Array.from(clonedElements.mobileParent.children).indexOf(mobileTab);
    currentElements.mobile = mobileTab; // Set initial current
  }
  
  if (desktopTab) {
    clonedElements.desktop = desktopTab.cloneNode(true);
    clonedElements.desktopParent = desktopTab.parentNode;
    clonedElements.desktopIndex = Array.from(clonedElements.desktopParent.children).indexOf(desktopTab);
    currentElements.desktop = desktopTab; // Set initial current
  }
  
  console.log('Cloned elements for mobile and desktop tabs saved');
}

// Function to remove current element (using reference for accuracy)
function removeCurrentElement(currentKey) {
  const element = currentElements[currentKey];
  if (element && element.parentNode) {
    element.remove();
    currentElements[currentKey] = null; // Clear reference
    console.log(`Removed current ${currentKey} tab`);
  }
}

// Function to attach events to new element (customize this for your needs)
function initEvents(newElement, type) { // type: 'mobile' or 'desktop' for specific logic
  // Example: Attach onclick to all buttons inside the tab
  const buttons = newElement.querySelectorAll('button'); // Or any selector for interactive elements
  buttons.forEach(button => {
    // If button has data-action, attach based on that (or hardcode)
    if (!button.hasAttribute('data-event-attached')) { // Avoid duplicate attachments
      button.addEventListener('click', (e) => {
        console.log(`Clicked button in ${type} tab:`, e.target.textContent);
        // Add your custom logic here, e.g., switchTab(e)
      });
      button.setAttribute('data-event-attached', 'true'); // Mark as attached
    }
  });
  
  // Example for tab-specific events
  if (type === 'mobile') {
    // Mobile-specific: e.g., touch events
    newElement.addEventListener('touchstart', () => console.log('Touch on mobile tab'));
  } else if (type === 'desktop') {
    // Desktop-specific: e.g., hover
    newElement.addEventListener('mouseenter', () => console.log('Hover on desktop tab'));
  }
  
  console.log(`Events re-attached for ${type} tab`);
}

// Function to add element back from clone (to original position)
function addElementFromClone(cloneKey) {
  const clone = clonedElements[cloneKey];
  const parent = clonedElements[`${cloneKey}Parent`];
  const index = clonedElements[`${cloneKey}Index`];
  
  if (clone && parent && !currentElements[cloneKey]) { // Avoid adding if already exists
    // Create new element from clone (identical)
    const newElement = clone.cloneNode(true); // Fresh clone each time
    
    // Insert at original index (or append if invalid)
    if (index >= 0 && index < parent.children.length + 1) { // +1 to account for removed element
      if (index === 0) {
        parent.prepend(newElement); // If index 0
      } else {
        const referenceNode = parent.children[index - 1] || null;
        parent.insertBefore(newElement, referenceNode ? referenceNode.nextSibling : parent.firstChild);
      }
    } else {
      parent.appendChild(newElement);
    }
    
    // Set as current
    currentElements[cloneKey] = newElement;
    
    // Re-attach events
    initEvents(newElement, cloneKey);
    
    console.log(`Re-added ${cloneKey} tab to original position`);
  } else if (currentElements[cloneKey]) {
    console.log(`Skipped adding ${cloneKey} tab: already exists`);
  }
}

// Function to toggle based on width
function toggleTabsBasedOnWidth() {
  const width = window.innerWidth;
  
  if (width > 768) {
    // Desktop: Remove mobile, add desktop
    removeCurrentElement('mobile');
    addElementFromClone('desktop');
  } else {
    // Mobile: Remove desktop, add mobile
    removeCurrentElement('desktop');
    addElementFromClone('mobile');
  }
}


  // Short poll to detect modal removal
function startModalPoll() {
    if (window.modalPolling) return; // Avoid multiple polls
    let previousModalExists = false; // Track state to detect transition from open to closed
    window.modalPolling = setInterval(() => {
        const modal = document.querySelector('.AirReviews-Modal__Wrapper.AirReviews-Modal__Wrapper--Open-Modal');
        const currentModalExists = !!modal;
        if (previousModalExists && !currentModalExists) {
            document.body.style.overflow = 'auto';
        }
        previousModalExists = currentModalExists;
    }, 1500);

}

// Initialize: Save clones first, then toggle initial state
document.addEventListener('DOMContentLoaded', () => {
  saveClonedElements(); // Save clones when DOM is ready
  toggleTabsBasedOnWidth(); // Apply initial logic
  // Start immediately
  startModalPoll();
});




